// Color constants
export const COLORS = {
  BADGE_BG: '#F5F5F5',
  BADGE_TEXT: '#000000',
  CASHBACK: '#0C8476',
  PRIMARY: '#0C8476',
  SECONDARY: '#F5F5F5',
} as const;

// Purchase channel types
export const PURCHASE_CHANNELS = {
  ONLINE: 'online',
  IN_STORE: 'in-store',
} as const;

// Badge text constants
export const BADGE_TEXT = {
  ONLINE: 'Online',
  IN_STORE: 'In-store',
  ONLINE_AND_IN_STORE: 'Online & In-store',
  NEARBY: 'Nearby',
} as const;